import Base, { Config } from 'components/Base';
import { Loading } from 'components/Modal';
import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface Props {
  onChange?: (e) => void;
  max?: number
  type?: 'video'
}

interface State {
  loading: boolean
}


export default class Uploader extends Base<any, State> {

 	public state: State = {
    loading: false
  };

  private handleFileChange = async(e) => {
    
    const { max } = this.props
    e.persist()
    if(!e.target){
      return;
    }
    let file = e.target.files
    let result:any[] = []
    
    this.toggleLoading(1)
    for( let i=0; i<file.length; i++ ){
      // console.log('path', file[i])
      if(result.length < max){
        const path = await this.interface.qiniuUploader(file[i])
        // console.log('path', path)
        result.push(path)
      }
    }
    this.toggleLoading(0)
    
    // for(let i in file){
    //   console.log('path', file[i].name)
    //   if(file[i].path){
        
    //   }
    // }

    // console.log(file.length, max, result)

    if(this.props.onChange){
      this.props.onChange(result)
    }
  }

  private toggleLoading = e => {
    this.setState({
      loading: !!e
    })
  }


	public render() {
    	const { className, type } = this.props;
      const { loading } = this.state;
      const accept = type == 'video'? 'video/*': 'image/*'
      const src = type == 'video'? this.assets.eswj.uploadVideo: this.assets.eswj.uploadImage

    	return (
        <div className={cx(styles.tab, className)}>
          <Loading isOpen={loading} />
          <div className={styles.box}>
            <img src={src} alt=""/>
            <input type="file" name="file" onChange={this.handleFileChange} multiple accept={accept} data-show-upload="false" data-show-caption="true"/>
          </div>
        </div>
    	)
  }
}
